module.exports = __webpack_public_path__ + "img/illustration-categories.423c713b.gif";